'use strict';

angular.module('AcaApp').controller('Form1094BController',
  [
    '$scope',
    '$mdDialog',
    '$location',
    '$route',
    'EmployerService',
    'ShortcutsService',
    'LayoutService',
    'FormService',
    'UtilsService',
    'FORM_MESSAGES',
    'currentEmployer',
    //jscs:disable maximumLineLength
    function($scope, $mdDialog, $location, $route, EmployerService, ShortcutsService, LayoutService, FormService, UtilsService, FORM_MESSAGES, currentEmployer){
      $scope.states = UtilsService.getStates();
      $scope.formChanged = false;
      if(currentEmployer !== undefined){
        $scope.form = currentEmployer;
      }
      else{
        $scope.form = {};
      }
      $scope.data = {};

      $scope.$watch('form', _formChanged, true);

      function _formChanged(newValue, oldValue){
        if(newValue !== oldValue){
          $scope.formChanged = true;
        }
      }

      $scope.fields = {
        validDate: true,
        validPin: true,
        validPinNumber: true,
        validDateCurrent: true,
        validContact: true,
        validContactphone: true,
        messageDate: '',
        messagePin: '',
        messagePinNumber: '',
        messageDateCurrent: '',
        messageContact: '',
        messageContactphone: ''
      };

      EmployerService.getPayerList().then(function(data){
        $scope.payers = data.result;
      },
      function(error){
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        $scope.errorMessage = (error.data.error.frontend_message || undefined);
      });

      $scope.evaluate = function(value1, value2){
        return LayoutService.selectedItemToUpperCase(value1, value2);
      };

      $scope.validateMandatory = function(){
        if($scope.form.ptin === undefined || $scope.form.ptin === ''){
          $scope.form.x4b_signaturepin = '';
          $scope.form.x4b_signaturetitle = '';
          $scope.form.x4b_signaturedate = '';
          setErrorMessage(FORM_MESSAGES.INCOMPLETE);
          return true;
        }
        else{
          getEmployerByPk($scope.form.ptin);
          setErrorMessage('');
          return false;
        }
      };

      $scope.save = function(form1094B){
        if(form1094B.$valid) {
          if($scope.form.ptin !== undefined && $scope.form.ptin !== '') {
            validateFields();
            if(validCondition()) {
              var rpcForm = {};
              rpcForm = $scope.form;
              rpcForm.x4b_signaturedate = ($scope.form.x4b_signaturedate !== '') ? $scope.form.x4b_signaturedate : null;
              rpcForm.x4c_signaturedate = ($scope.form.x4c_signaturedate !== '') ? $scope.form.x4c_signaturedate : null;

              FormService.save1094b(rpcForm).then(
                function(){
                  $mdDialog.hide();
                  $mdDialog.show({
                    controller: [
                      '$scope',
                      function($scope){
                        $scope.titleUI = 'Creation';
                        $scope.descriptionUI = 'created';
                        $scope.formType = 'B';
                        $scope.closeModal = function(){
                          ShortcutsService.enableBackSpaceDefault();
                          $mdDialog.hide();
                          reloadEmployer();
                        };
                      }
                    ],
                    templateUrl: 'app/views/form/modals/add1094CSuccessMessage.html'
                  });
                },
                function(error){
                  setErrorMessage(error.data.error.frontend_message);
                }
              );
            }
            else{
              var errorMessage = !($scope.fields.validDate) ? $scope.fields.messageDate + '\n' : '';
              errorMessage += !($scope.fields.validPin) ? $scope.fields.messagePin + '\n' : '';
              errorMessage += !($scope.fields.validPinNumber) ? $scope.fields.messagePinNumber + '\n' : '';
              errorMessage += !($scope.fields.validDateCurrent) ? $scope.fields.messageDateCurrent + '\n' : '';
              errorMessage += !($scope.fields.validContact) ? $scope.fields.messageContact + '\n' : '';
              errorMessage += !($scope.fields.validContactphone) ? $scope.fields.messageContactphone + '\n' : '';
              setErrorMessage(errorMessage);
            }
          }
          else{
            setErrorMessage(FORM_MESSAGES.INCOMPLETE);
          }
        }
        else{
          setErrorMessage(FORM_MESSAGES.INCOMPLETE);
        }
      };

      var validCondition = function(){
        return (
          $scope.fields.validPin &&
          $scope.fields.validDate &&
          $scope.fields.validPinNumber &&
          $scope.fields.validDateCurrent &&
          $scope.fields.validContact &&
          $scope.fields.validContactphone
        );
      };

      var reloadEmployer = function(){
        $location.path('records').search({section: 'recordEmployer'});
        $route.reload();
      };

      $scope.checkNumber = function(event){
        return UtilsService.checkCharacter(event);
      };

      $scope.checkName = function(event){
        return UtilsService.checkAlphaCharacter(event);
      };

      $scope.requiredFields = function(field){
        if(field === 'editContact'){
          $scope.contactRequerid = true;
        }
        if(field === 'editContactPhone'){
          $scope.contactPhoneRequerid = true;
        }
       if(field==='editSignaturePin'){
          $scope.signaturePinRequired = true;
        }
        $scope.errorMessage = '';
      };

      var setErrorMessage = function(value){
        $scope.errorMessage = value;
      };

      var getEmployerByPk = function(ptin){
        EmployerService.GetEmployerByPk(ptin).then(function(data){
          data.result.x4b_signaturedate = checkSignatureDate(data.result.x4b_signaturedate);
          $scope.form = data.result;
        },
          function(error){
            console.log('Error', error);
          }
        );
      };

      var validateFields = function(){
        if($scope.form.x4b_signaturedate !== undefined && $scope.form.x4b_signaturedate !== '') {
          $scope.fields.validDate = UtilsService.checkValidDate($scope.form.x4b_signaturedate);
          $scope.fields.messageDate = !($scope.fields.validDate) ? FORM_MESSAGES.INVALIDDATE : '';
          $scope.fields.validDateCurrent = UtilsService.checkMostDateCurrent($scope.form.x4b_signaturedate);
          $scope.fields.messageDateCurrent = !($scope.fields.validDateCurrent) ? FORM_MESSAGES.MOSTDATECURRENTB : '';
        }
        if($scope.form.x4b_signaturepin !== undefined && $scope.form.x4b_signaturepin !== '') {
          $scope.fields.validPin = UtilsService.checkTenCharacters($scope.form.x4b_signaturepin);
          $scope.fields.messagePin = !($scope.fields.validPin) ? FORM_MESSAGES.INVALIDPIN : '';
          $scope.fields.validPinNumber = UtilsService.checkIsNumber($scope.form.x4b_signaturepin);
          $scope.fields.messagePinNumber = !($scope.fields.validPinNumber) ? FORM_MESSAGES.INVALIDPINNUMBER : '';
        }
        if($scope.form.x4b_signaturetitle !== undefined && $scope.form.x4b_signaturetitle !== '') {
          $scope.form.x4b_signaturetitle = $scope.form.x4b_signaturetitle.replace(/ +/g, ' ');
        }
        if($scope.form.contact !== undefined && $scope.form.contact !== '') {
          $scope.form.contact = $scope.form.contact.replace(/ +/g, ' ');
        }
        if($scope.form.contact !== undefined && $scope.form.contact !== '') {
          $scope.fields.validContact = UtilsService.checkContact($scope.form.contact);
          $scope.fields.messageContact = !($scope.fields.validContact) ? FORM_MESSAGES.INVALIDCONTACT : '';
        }
        if($scope.form.contactphone !== undefined && $scope.form.contactphone !== '') {
          $scope.fields.validContactphone = UtilsService.checkContactPhone($scope.form.contactphone);
          $scope.fields.messageContactphone = !($scope.fields.validContactphone) ? FORM_MESSAGES.INVALIDCONTACTPHONE : '';
        }
      };
        
      var checkSignatureDate = function(date){
        return (date !== undefined) ? UtilsService.getUnixTimestamp(date).split(' ')[0] : '';
      };

      $scope.doesHaveOwnPin = $scope.form.x4b_signaturepin ? true : false;

      $scope.cleanOwnSignatureFields = function(){
          $scope.form.x4b_signaturepin = '';
          $scope.form.x4b_signaturetitle = '';
          $scope.form.x4b_signaturedate = '';
      }

      LayoutService.addDatepickerRangeDate('#signaturedate');
    }
  ]);
